import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { capitalize } from '@mui/material/utils';
import MUILink from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { FindHeadlinksProps } from "./Find.types"
import { H3, H4, Small } from "../../../design/common/template/Typography"
import { useEffect, useMemo, useState } from "react"
import dynamic from "next/dynamic"
import { useLayoutData } from "../../../utils/contexts/LayoutContext"
import { PageType } from "../../../pages/_app"
import Link from "next/link"
import { FindHeadlinkItemProps } from "./FindDesignTypes"
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from "next-i18next"

const FindHeadlinks = ({
	title,
	headlinks
}: FindHeadlinksProps) => {
	const { partnerSiteFull, templatePath } = useLayoutData()
	const { t } = useTranslation()

	const [showAll, setShowAll] = useState<boolean>(false)

	const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath
	
	const FindHeadlinkItem = useMemo(
    () =>
      dynamic<FindHeadlinkItemProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindHeadlinkItem)
      ),
    [path]
  )

	const MAX_SHOW_NUMBER = 12
	const showAllButton = (headlinks && headlinks?.length > MAX_SHOW_NUMBER && !showAll) ?? false
	const sliceNumber = showAll ? headlinks?.length : MAX_SHOW_NUMBER === headlinks?.length ? headlinks?.length : MAX_SHOW_NUMBER - 1

	const showHeadlinks = headlinks && headlinks.length > 0

	useEffect(() => {
		setShowAll(false)
	}, [headlinks])

	return (
		<Grid container mb={5}>
			<Grid item xs={12}>
				<Card>
					<CardContent>
						<Grid container columnSpacing={2}>
							{title ? (
								<Grid item xs={12}>
									<FindHeadlinkItem istitle={1} noheadlink={Number(!showHeadlinks)}>
										<H3 component={"h1"} textTransform={"none"}>{capitalize(title as string)}</H3>
									</FindHeadlinkItem>
								</Grid>
							) : null}
							{showHeadlinks ? headlinks?.slice(0,sliceNumber).map((item, i) => {
								return (
									<Grid key={i} item xs={12} sm={6} lg={4}>
										<Link href={item.url as string} passHref>
											<FindHeadlinkItem component={"a"}>
												<H4 component={"div"} fontWeight={"normal"}>{capitalize(item.text as string)}</H4>
												<Small>{item.count}</Small>
											</FindHeadlinkItem>
										</Link>
									</Grid>
								)
							}) : null}
							{showHeadlinks && showAllButton ? (
								<Grid item xs={12} sm={6} lg={4}>
									<FindHeadlinkItem>
										<MUILink component={"span"} underline="none" onClick={() => setShowAll(true)} sx={{ cursor: "pointer" }}>
											<Stack display={"flex"} direction={"row"} alignItems={"center"}>
												<H4 component={"div"} fontWeight={"normal"} mr={0.5}>{t('web.listing.headlinks.tovabbiakTitle')}</H4>
												<ArrowForwardIosIcon sx={{ fontSize: 12 }} />
											</Stack>
										</MUILink>
									</FindHeadlinkItem>
								</Grid>
							) : null}
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	)
}

export default FindHeadlinks